<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Consolidation Points'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'ConsolidationPointSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Origin', prop: (location) => location.originPort ? location.originPort.name : '' },
          { header: 'Destination', prop: (location) => location.destinationPort ? location.destinationPort.name : '' }
        ],
        loading: false,
        tableData: [],
        entityName: 'consolidation-point',
        editEntityScreen: 'Admin - Edit/View Consolidation Point',
        shouldSearchForExactMatch: true,
        orderBy: 'originPort'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// ConsolidationPointSearchResults.vue?de1ece62